import React from "react";
import {
  Box,
  Container,
  makeStyles,
} from "@material-ui/core";
import PeopleIcon from "@material-ui/icons/People";

import Page from "src/components/Page";
import Create from "./Create";
import PageHeader from "../../components/PageHeader";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: "#f7f7fa",
    minHeight: "100%",
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(4),
  },

  content: {
    marginTop: theme.spacing(3),
  },
}));

const Index = () => {
  const classes = useStyles();

  return (
    <Page
      className={classes.root}
      title="Users"
    >
      <Container maxWidth="lg">
        <PageHeader
          icon={<PeopleIcon />}
          title="Users"
          subtitle="Manage and view user accounts"
          showSession
        />

        <Box className={classes.content}>
          <Create />
        </Box>
      </Container>
    </Page>
  );
};

export default Index;